import {Component, Input, Output, EventEmitter} from '@angular/core'
import {Role, Permission} from '../../models';
import {HttpService} from '../../services';
import {Response} from '@angular/http';
import {RolesService} from "../../services/roles.service";
import {ResponseApi} from "../../services/response/response";

@Component({
    moduleId: module.id,
    selector: 'role',
    templateUrl: 'role.component.html',
    providers: [HttpService]
})
export class RoleComponent {
    _role: Role = new Role(-1, '');
    isEdit: boolean = false; // Добавляется ли новая роль.
    _permissions: Permission[] = [];
    Statuses = [];

    @Input("roleId")
    set in(roleId: number) {
        if (roleId != undefined) {
            this.getRole(roleId);
            this.isEdit = true;
        }
        else {
            this._role = new Role(-1, '');
            this.isEdit = false;
        }


        this.getPermissions(roleId);
    }

    @Output() onSave = new EventEmitter();
    @Output() onCancel = new EventEmitter();

    constructor(private rolesService: RolesService) {
        this.Statuses[1] = "Действующая";
        this.Statuses[2] = "Удаленная";
        this.Statuses[3] = "Заблокированная";
    }

    getRole(roleId: number) {
        this.rolesService.getRole(roleId).subscribe((resp: ResponseApi) => {
            let roleData = resp.data;
            this._role.Id = roleData['Id'];
            this._role.Title = roleData['Title'];
            this._role.Status = roleData['Status'];
        })
    }

    getPermissions(roleId: number) {
        this.rolesService.getPermissions(roleId).subscribe((data) => this._permissions = data.data);
    }

    save() {
        this._role.Permissions = new Array<Object>();

        for (let index in this._permissions)
            if (this._permissions[index].IsActive)
                this._role.Permissions.push({Id: this._permissions[index].Id, Title: this._permissions[index].Title});

        if (this._role.Id != null && this._role.Id != -1)
            this.rolesService.updateRole(this._role).subscribe((resp: ResponseApi) => {
                let r = resp;

                if (r.code)
                    alert(r.msg);
                else
                    this.onSave.emit();
            });
        else
            this.rolesService.addRole(this._role).subscribe((resp: ResponseApi) => {
                let r = resp;
                if (r.code)
                    alert(r.msg);
                else
                    this.onSave.emit();
            });
    }

    delete() {
        this.rolesService.deleteRole(this._role.Id);
    }

    cancel() {
        this.onCancel.emit();
    }
}